import { appendTestableElementAttributes, ChevronLeftIcon, ChevronRightIcon } from '@dreryk/react-components';

import { Direction } from './HorizontalScrollerNavigation.types';
import {
   StyledHorizontalScrollerNavigationButton,
   StyledHorizontalScrollerNavigationContainer,
} from './HorizontalScrollerNavigation.styled';

type HorizontalScrollerNavigationPropsProps = {
   direction: Direction;
   onClick: VoidFunction;
   visible: boolean;
};

export const HorizontalScrollerNavigation = (props: HorizontalScrollerNavigationPropsProps): JSX.Element => (
   <StyledHorizontalScrollerNavigationContainer $direction={props.direction} $visible={props.visible}>
      <StyledHorizontalScrollerNavigationButton
         $visible={props.visible}
         {...appendTestableElementAttributes(`${props.direction}ScrollButton`)}
         onClick={props.onClick}
      >
         {props.direction === 'left' && <ChevronLeftIcon />}
         {props.direction === 'right' && <ChevronRightIcon />}
      </StyledHorizontalScrollerNavigationButton>
   </StyledHorizontalScrollerNavigationContainer>
);
